import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { SelectableInput } from "../../../../dynamic-forms/inputs/selectable-input.model";
import { ListItem } from "../../../../shared/list/list-item";
import { VendorDetail } from "./vendor-detail.model";

@Injectable({
  providedIn: "root",
})
export class VendorDetailService {

  constructor(@Inject(BASE_API_URL)
  private readonly baseApiUrl: string,
              private httpClient: HttpClient,
              private automapper: AutomapperService
  ) {
  }

  saveVendorDetails(vendorDetail: VendorDetail): Observable<number> {
    const url = `${this.baseApiUrl}invoice/vendor/save`;
    return this.httpClient.post(url, vendorDetail) as Observable<number>;
  }

  getPaymentMethods(): Observable<ListItem[]> {
    const url = `${this.baseApiUrl}invoice/vendor/paymentmethod`;
    return this.httpClient.get(url).pipe(map(this.automapper.curryMany("default", "ListItem")));

  }

  getVendor(vendorId: number): Observable<VendorDetail[]> {
    const url = `${this.baseApiUrl}invoice/vendor?vendorId=${vendorId}`;
    return this.httpClient.get(url)
      .pipe(map(this.automapper.curryMany("default", "VendorDetail")));
  }

  getChartType(): Observable<ListItem[]> {
    const url = `${this.baseApiUrl}invoice/vendor/charttype`;
    return this.httpClient.get(url)
      .pipe(map(this.automapper.curryMany("default", "ListItem")));

  }

  getInvoicingOption(): SelectableInput[] {
    const invoicingOption: SelectableInput[] = [];
    invoicingOption.push({ text: "pre-billed", label: "pre-billed", value: "pre-billed", disabled: false, extra: "" },
                         { text: "reconciled", label: "reconciled", value: "reconciled", disabled: false, extra: "" },
                         { text: "other", label: "other", value: "other", disabled: false, extra: "" });
    return invoicingOption;
  }

  getMSAOption(): SelectableInput[] {
    const msaOption: SelectableInput[] = [];
    msaOption.push({ text: "YES", label: "YES", value: "YES", disabled: false, extra: "" },
                   { text: "NO", label: "NO", value: "NO", disabled: false, extra: "" });
    return msaOption;
  }

  getRequestMethodOption(): SelectableInput[] {
    const rmOption: SelectableInput[] = [];
    rmOption.push({ text: "BestFit", label: "BestFit", value: "BestFit", disabled: false, extra: "" },
                  { text: "BestFit / PSR Identified", label: "BestFit / PSR Identified", value: "BestFit / PSR Identified", disabled: false, extra: "" },
                  { text: "PSR Identified", label: "PSR Identified", value: "PSR Identified", disabled: false, extra: "" });
    return rmOption;
  }
}

